import { ref } from "vue";
import { defineStore } from "pinia";
import api from "@/api";
import type { UserDetail } from "@/api";

const STORAGE_KEY = "userAdminSaveAccess";

export const useSessionStore = defineStore("session", () => {
    const canSave = ref(true);

    const init = (selfUser: UserDetail) => {
        if (!api.auth.isImpersonating) {
            // Real user session — store their save access for when they impersonate
            const attr = selfUser.attributes["USER_ADMIN_SAVE_ACCESS"];
            const access = !attr || (attr.value !== "0" && attr.value !== "false");
            sessionStorage.setItem(STORAGE_KEY, String(access));
            canSave.value = true;
        } else {
            // Impersonating — read the real user's access stored before the page reloaded
            const stored = sessionStorage.getItem(STORAGE_KEY);
            canSave.value = stored === null ? true : stored === "true";
        }
    };

    return { canSave, init };
});
